interface EmiteLogoProps {
  size?: number;
  className?: string;
}

export default function EmiteLogo({ size = 32, className = "" }: EmiteLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
      fill="none"
    >
      <path
        d="M16 3C9.4 3 4 8.4 4 15s5.4 12 12 12c5.2 0 9.6-3.3 11.3-7.9h-5.4C20.8 21.1 18.6 22.5 16 22.5c-3.6 0-6.4-2.6-7-6h17.8c.1-.5.2-1 .2-1.5C27 8.4 22.1 3 16 3zm-7 10c.6-3.4 3.4-6 7-6s6.4 2.6 7 6H9z"
        fill="currentColor"
      />
      <path
        d="M21 9l-5.5 8L12 13.5"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
